import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SignalCellularConnectedNoInternet0BarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"signal_cellular_connected_no_internet_0_bar"}/>
}
